jQuery(document).ready(function(){
    Util.setiFrameTitle('oil-change-educational-video', 'Oil Change educational video');
    Util.setiFrameTitle('tire-replacement-educational-video', 'Tire Replacement educational video');
});